import React from "react";
import PropTypes from "prop-types";
import Overlay from "../Overlay";
import OverlayButton from "../OverlayButton";

const BackToDomDotCom = ({
  closeOverlay,
  buildRedirectURL,
  payload,
  openExternalUrl
}) => {
  const goToDomDotCom = () => {
    const redirectURL = buildRedirectURL(payload);

    openExternalUrl(redirectURL);
  };

  return (
    <Overlay closeOverlay={closeOverlay} className={"return"}>
      <h1 data-quid="return-to-dominos-text">Return to dominos.com</h1>
      <h2>Would you like to go back to dominos.com to start over?</h2>
      <h2>Your order settings will be reset.</h2>
      <div className="button__container">
        <OverlayButton
          quid="return-btn-no-cancel"
          buttonType={"button"}
          buttonText={"no, cancel"}
          buttonClass={"blue"}
          buttonAction={closeOverlay}
        />
        <OverlayButton
          quid="return-btn-yes-go-back"
          buttonType={"button"}
          buttonText={"yes, go back"}
          buttonClass={"red"}
          buttonAction={goToDomDotCom}
        />
      </div>
    </Overlay>
  );
};

BackToDomDotCom.propTypes = {
  closeOverlay: PropTypes.func.isRequired,
  payload: PropTypes.string.isRequired,
  buildRedirectURL: PropTypes.func.isRequired,
  openExternalUrl: PropTypes.func.isRequired
};

export default BackToDomDotCom;
